import { useEffect, useState } from "react";
import { NavLink, Link, Outlet, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { DeckButton } from "./DeckButton";
import { Toaster } from "./ui/sonner";

const LINKS = [
  { to: "/", label: "Home", id: "home" },
  { to: "/episodes", label: "Episodes", id: "episodes" },
  { to: "/characters", label: "Characters", id: "characters" },
  { to: "/about", label: "About", id: "about" },
];

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = setTimeout(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

const Nav = () => {
  const [open, setOpen] = useState(false);
  const cls = ({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`;
  return (
    <header className="site-nav" data-testid="site-nav">
      <div className="wrap flex items-center justify-between h-16">
        <Link to="/" className="brand" data-testid="nav-brand">Then Came <em>Sam</em></Link>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end className={cls} data-testid={`nav-${l.id}`}>{l.label}</NavLink>
          ))}
          <DeckButton testid="nav-download-deck-btn" className="nav-link nav-deck" short />
        </nav>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden wrap pb-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end className={cls} onClick={() => setOpen(false)} data-testid={`nav-mobile-${l.id}`}>{l.label}</NavLink>
          ))}
          <DeckButton testid="nav-mobile-download-deck-btn" className="nav-link nav-deck self-start" short />
        </nav>
      )}
    </header>
  );
};

const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="wrap py-14 flex flex-col md:flex-row md:items-end justify-between gap-6">
      <div>
        <p className="brand text-3xl">Then Came <em>Sam</em></p>
        <p className="slate mt-3">A live-action half-hour sitcom · Malibu, California</p>
      </div>
      <nav className="flex gap-6 flex-wrap">
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} className="nav-link" data-testid={`footer-${l.id}`}>{l.label}</Link>
        ))}
      </nav>
    </div>
  </footer>
);

export default function Layout() {
  return (
    <>
      <ScrollManager />
      <Nav />
      <main><Outlet /></main>
      <Footer />
      <Toaster position="bottom-right" />
    </>
  );
}
